import { render, staticRenderFns } from "./MiCuenta.vue?vue&type=template&id=5a5119db&scoped=true"
import script from "./MiCuenta.vue?vue&type=script&lang=js"
export * from "./MiCuenta.vue?vue&type=script&lang=js"
import style0 from "./MiCuenta.vue?vue&type=style&index=0&id=5a5119db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5119db",
  null
  
)

export default component.exports